import { TemplateReadPublic } from "@/store/baseClientApi";
import { setTemplate, TemplateSlice } from "@/store/slices/templateSlice";
import { store } from "@/store/store";

export const changeTemplate = (template: TemplateReadPublic) => {
  const gingivalTrimDistance = template.case_options.base_params?.gingival_trim_distance;

  store.dispatch(
    setTemplate({
      templateId: template.id,
      name: template.name,
      modelType: template.case_options.base_params?.full_palate ? "full_palate" : "horse_shoe",
      attachments: template.case_options.attachment_params?.attachment_type ?? undefined,
      isHollow: template.case_options.base_params?.hollow ?? false,
      textStyle: template.case_options.text_params?.text_style ?? undefined,
      gingivalTrimEnabled: gingivalTrimDistance != null,
      gingivalTrimDistance: gingivalTrimDistance ?? 5,
      gingivalTrimSliderActive: false
    })
  );
};

export const TemplateSliceToCaseOptions = (template: TemplateSlice) => ({
  base_params: {
    hollow: template.isHollow,
    full_palate: template.modelType === "full_palate",
    gingival_trim_distance: template.gingivalTrimEnabled ? template.gingivalTrimDistance : null
  },
  attachment_params: {
    attachment_type: template.attachments
  },
  text_params: {
    text_style: template.textStyle
  }
});
